module.exports = __webpack_public_path__ + "static/img/42-北京第二实验小学(德胜校区)1.259db14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/42-北京第二实验小学(德胜校区)1.png
// module id = dCRF
// module chunks = 0